import { hasPermission, hasAnyPermission } from '@/utils/permissions';

/**
 * Hook para verificar permisos del usuario actual
 */
export const usePermissions = (user) => {
  const userPermissions = user?.permissions || [];
  const isAdmin = user?.is_admin || false;

  // Si es admin, tiene todos los permisos
  if (isAdmin) {
    return {
      hasPermission: () => true,
      hasAnyPermission: () => true,
      canView: () => true,
      canCreate: () => true,
      canEdit: () => true,
      canDelete: () => true,
      isAdmin: true
    };
  }

  return {
    hasPermission: (permission) => hasPermission(userPermissions, permission),
    hasAnyPermission: (permissions) => hasAnyPermission(userPermissions, permissions),
    canView: (module) => hasPermission(userPermissions, `${module}.view`),
    canCreate: (module) => hasPermission(userPermissions, `${module}.create`),
    canEdit: (module) => hasPermission(userPermissions, `${module}.edit`),
    canDelete: (module) => hasPermission(userPermissions, `${module}.delete`),
    isAdmin: false
  };
};
